const route = [
    {
        path: '/activity/2023qmjc/index', //2023上期中检测
        component: function (resolve) {
            require(['VIEWS/activity/2023qmjc/index.vue'], resolve);
        }
    },
]
export default route;
